import { baseBackendUrl, getBackend } from "./baseService";
import { login } from "../models/login";

export const AuthService = async (
  info: login,
  onComplete: Function,
  onError: () => void
) => {
  await getBackend()
    .post(baseBackendUrl + "/api/login", {
      email: info.email,
      password: info.password,
    })
    .then(function (response) {
      onComplete(response);
    })
    .catch(function (error) {
      onError();
    });
};

export const getUsers = async (
  token: string,
  onComplete: Function,
  onError: () => void
) => {
  await getBackend()
    .get(baseBackendUrl + "/api/users", {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      onComplete(response);
    })
    .catch(function (error) {
      onError();
    });
};

export const addRole = async (
  token: string,
  email: string,
  roleName: string,
  onComplete: Function,
  onError: () => void
) => {
  await getBackend()
    .post(baseBackendUrl + "/api/AddRole", {
      email: email,
      roleName: roleName,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      onComplete(response);
    })
    .catch(function (error) {
      onError();
    });
};


